import i18n from '@/i18n';

/**
 * Language sent in the `Accept-Language` header of requests that build their own headers, so the
 * server localizes generated files (exports and import templates) in the selected app language.
 * @returns "en" when the selected app language is English, otherwise "id"
 */
export const getRequestLanguage = (): 'id' | 'en' =>
  (i18n.language || 'id').toLowerCase().startsWith('en') ? 'en' : 'id';
